<nz-pagination
  (nzPageIndexChange)="pageIndexChange($event)"
  (nzPageSizeChange)="pageSizeChange($event)"
  [nzHideOnSinglePage]="true"
  [nzPageIndex]="pageIndex"
  [nzPageSize]="pageSize"
  [nzShowSizeChanger]="(total || 0) / 10 > 2"
  [nzTotal]="total"
></nz-pagination>
